// Enhanced click-to-play for Shopify-hosted videos
document.addEventListener('click', function(e) {
  const poster = e.target.closest('.deferred-media__poster');
  if (!poster) return;

  const deferred = poster.closest('deferred-media');
  if (!deferred) return;

  // Load the deferred content (video)
  deferred.loadContent();

  // Small delay to ensure video is in the DOM
  setTimeout(() => {
    const video = deferred.querySelector('video');
    if (video && video.paused) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Hide poster after video starts playing
            poster.style.display = 'none';
          })
          .catch(err => {
            console.log('Autoplay blocked by browser:', err);
            // Fallback: show native controls if autoplay is blocked
            video.controls = true;
          });
      }
    }
  }, 100); // tiny delay ensures video element exists
}, { passive: true });